

const ArabicLanguage = [
    {
        about:"من نحن",
    },
    {
        service:"خدماتنا",
    },
    {
        projects:"مشارعينا",
    },
    {
        design:"ًتصميم",
    },
    {
        develop:"تطوير",
    },
    {
        and:"و",
    },
    {
        create:'أنشاء المواقع'
    },
    {
        software:'الأنظمة'
    },
    {
        system:'الألكترونية'
    },
    {
        uniqueDesign :'تصميم وجهات فريد من نوعه',
    },
    {
        responsive :'متوافق مع جميع الشاشات',
    },
    {
        support :'دعم فني علي مدار الأسبوع',
    },
    {
        platforms :'وجهات أحترافية',
    },
    {
        commerce :'متجر الكتروني',
    },
    {
        custom :'تصميم مميز',
    },
    {
        systemsAnalysis :'أنظمة متكاملة',
    },
    {
        demosTitle :'نحن متخصصون في تعزيز العالم من حولنا، اكتشفه الآن',
    },
    {
        clientsTitle :'.لقد حصلنا على ثقة عملائنا الكرام',
    },
];
export default ArabicLanguage